import React from "react";

const AboutUs = () => {
  return (
    <section className="py-30">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 order-lg-1 order-2 py-60 aboutus-text">
            <h4 className="m-0">Our Story</h4>
            <p>
              Welcome to SupplyNest! At SupplyNest, we are committed to
              providing quality products and exceptional service to our
              customers. Based in the heart of Hawally, Kuwait, we strive to be
              your trusted partner for all your supply needs.
            </p>
            <p>
              Since our establishment, we have focused on delivering value,
              reliability, and satisfaction. Our team is passionate about
              understanding your needs and offering solutions that help you grow
              and succeed. Whether you're shopping for business essentials or
              personal use, SupplyNest is here to serve you with dedication and
              care.
            </p>
            <p>
              Have questions or need assistance? Reach out to us at: <br />
              <a href="#" className="info-custom text-lg">
                <b>+965 1234578</b>
              </a>
              &nbsp; &nbsp; or &nbsp; &nbsp;
              <a href="#" className="info-custom text-lg">
                <b>info@supplynest.com</b>
              </a>
            </p>
            <p>
              Our location:
              <br />
              <a href="#" className="info-custom">
                <b>
                  Shop No. 7, AL Zenia Complex 2, 
                  <br/>
                  Ground Floor, Near McDonald's,
                  <br/>
                  Ibn Khaldoun Street, 
                  <br/>
                  Hawally, Kuwait.
                </b>
              </a>
              <br />
            </p>
            <p>
              We're always happy to help! Thank you for choosing SupplyNest. We
              look forward to serving you!
            </p>
          </div>
          <div className="col-lg-6 order-lg-2 order-1 d-flex justify-content-end align-items-center">
            <div className="AboutUs-Logo">
              <img
                src="assets\images\icon\AboutUs Logo.jpg"
                alt=""
                className="img-fluid custom-image"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="py-60 container">
        <div className="row">
          <div className="col-lg-3 mt-18">
            <div className="card text-center align-items-center">
              <img
                src="assets\images\icon\shop.png"
                alt=""
                className="custom-img"
              />
              <h5>10.5K</h5>
              <p>Sallers active our site</p>
            </div>
          </div>
          <div className="col-lg-3 mt-18">
            <div className="card text-center align-items-center">
              <img
                src="assets\images\icon\dollor.png"
                alt=""
                className="custom-img2"
              />
              <h5>33K</h5>
              <p>Monthly Product Sale</p>
            </div>
          </div>
          <div className="col-lg-3 mt-18">
            <div className="card text-center align-items-center">
              <img
                src="assets\images\icon\shopping-bags.png"
                alt=""
                className="custom-img"
              />
              <h5>45.5K</h5>
              <p>Customer active in our site</p>
            </div>
          </div>
          <div className="col-lg-3 mt-18">
            <div className="card text-center align-items-center">
              <img
                src="assets\images\icon\money.png"
                alt=""
                className="custom-img"
              />
              <h5>50K</h5>
              <p>Anual gross sale in our site</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
